import React, { useEffect } from 'react';

const SuccessModal = ({ message, onClose }) => {
  // Removed the navigation logic

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose(); // Close the modal after 3 seconds
    }, 3000); // Delay for 3 seconds

    // Clear the timer on component unmount
    return () => clearTimeout(timer);
  }, [onClose]);

  const modalStyle = {
    position: 'fixed',
    top: '0',
    left: '0',
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.4)', // Semi-transparent background
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
    animation: 'fadeIn 0.5s ease-in-out', // Adding fade-in animation
  };

  const modalContentStyle = {
    background: 'linear-gradient(135deg, #6b00b6, #00bcd4)', // Gradient background
    color: 'white',
    padding: '30px',
    borderRadius: '15px',
    width: '350px',
    textAlign: 'center',
    boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.2)', // Add shadow for depth
    animation: 'slideUp 0.5s ease-in-out',
  };

  const modalHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '15px',
  };

  const closeButtonStyle = {
    background: 'none',
    border: 'none',
    fontSize: '25px',
    color: 'white',
    cursor: 'pointer',
    transition: 'color 0.3s ease',
  };

  const messageStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '20px',
    padding: '10px 20px',
    borderRadius: '8px',
    backgroundColor: '#00bcd4',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
  };

  return (
    <div style={modalStyle}>
      <div style={modalContentStyle}>
        <div style={modalHeaderStyle}>
          <h3>Success!</h3>
          <button style={closeButtonStyle} onClick={onClose}>✖</button>
        </div>
        <p style={messageStyle}>{message}</p>
      </div>
    </div>
  );
};

export default SuccessModal;
